<template>
  <div class="doge-shell">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">好友互转</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section class="swap-box"><div class="asset"><span>从</span><b>USDT</b></div><button class="swap">⇅</button><div class="asset"><span>到</span><b>好友账户</b></div></section>
      <section class="doge-card">
        <label>好友地址/UID</label><input class="doge-input" v-model="to" placeholder="请输入好友钱包地址/UID/手机号/邮箱">
        <label>数量</label><div class="amount-box"><input v-model="amount" type="number" placeholder="请输入数量"><button @click="amount=maxAmount">最多</button></div>
        <button class="doge-btn full" :disabled="submitting" @click="submit">{{ submitting ? '提交中...' : '确认' }}</button>
        <p class="doge-muted">最多可转：{{ money(maxAmount) }} USDT</p>
      </section>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import BottomNav from '../../components/layout/BottomNav.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'friendTransfer',
  components: { BottomNav },
  data() { return { to: '', amount: '', submitting: false }; },
  computed: { ...mapGetters(['getUserDetails']), maxAmount() { return this.getUserDetails && this.getUserDetails.balance || 0; } },
  methods: {
    async submit() {
      if (!this.to || !this.amount) return this.msg('请填写收款账号和转账数量');
      this.submitting = true;
      try {
        await this.$store.dispatch('ensureDogeAuth');
        const r = await this.$axios.post('/api/doge/friend_transfer', { target: this.to, amount: this.amount });
        if (![1, 200].includes(Number(r.data.code))) throw new Error(r.data.message || r.data.msg || '转账没有成功，请稍后再试');
        this.msg('互转成功', 'success');
        this.to = ''; this.amount = '';
        this.$store.dispatch('fetchUserDetails');
      } catch (e) {
        this.msg((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || '转账没有成功，请稍后再试', 'error');
      } finally { this.submitting = false; }
    },
    money(v) { return Number(v || 0).toFixed(2); },
    msg(t, type = 'info') { this.$messageDialog ? this.$messageDialog.alert(t, '提示', type) : alert(t); }
  }
};
</script>
<style scoped>.swap-box{position:relative;margin:18px 0 24px}.asset{height:104px;border:1px solid #ead9b6;border-radius:18px;background:#fff;padding:18px;display:flex;flex-direction:column;justify-content:center;box-shadow:0 6px 18px rgba(75,52,0,.07)}.asset+.asset{margin-top:12px}.asset span{color:var(--doge-muted)}.asset b{font-size:22px;margin-top:8px;color:#211507}.swap{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:48px;height:48px;border-radius:50%;border:0;background:linear-gradient(145deg,#d89a2e,#f0d37c);font-size:24px;color:#fff;box-shadow:0 4px 12px rgba(211,155,44,.35)}.doge-card label{display:block;font-weight:800;margin:12px 0 8px}.amount-box{display:flex;align-items:center;border:1px solid #ead9b6;border-radius:14px;margin:0 0 8px;padding:0 10px;background:#fff}.amount-box input{height:52px;flex:1;border:0;background:transparent;color:#211507;outline:none}.amount-box button{border:0;background:var(--doge-primary);color:#fff;border-radius:999px;padding:7px 12px}.doge-btn{margin-top:18px}</style>
